export default () => ({
  type: 'CLEAR_USER',
});
